<template>
    <div>
        <div class="wrapper-read-only mt-5" v-if="observation">
            <v-card class="pa-2" outlined :class=" observation ? 'editor-background' : '' ">
                <div class="editor">
                    <editor-content class="editor__content" :editor="editor" />
                </div>
            </v-card>
        </div>
        <div class="editor" v-else>
            <editor-content class="editor__content" :editor="editor" />
        </div>
    </div>
</template>

<script>
import { Editor, EditorContent } from 'tiptap'
import {
    BulletList,
    ListItem,
    OrderedList,
    Bold,
    Italic,
    Link,
    Strike,
    Underline
} from 'tiptap-extensions'
export default {
    name: 'read-only',
    props: ['text', 'observation'],
    components: {
        EditorContent
    },
    data () {
        return {
            editor: null
        }
    },
    mounted () {
        this.editor = new Editor({
            extensions: [
                new BulletList(),
                new ListItem(),
                new OrderedList(),
                new Link(),
                new Bold(),
                new Italic(),
                new Strike(),
                new Underline()
            ],
            editable: false,
            content: this.text
        })
    },
    watch: {
        'text': {
            handler: function () {
                this.editor.setContent(this.text === '' ? 'Observações' : this.text)
                this.$forceUpdate()
            }
        }
    }
}
</script>
<style lang="scss">
.editor-background {
    background-color: #E0E0E0 !important;
}

.wrapper-read-only {
    .editor{
        .editor__content{
            height: 100%;
        }

        width: 100%;
        line-height: 20px;
        overflow-y: scroll;
        height: 100px;
        max-height: 400px;

        .ProseMirror{
            height: 100%;
            outline-width: 0;

            p{
                margin: 0px
            }
        }

        p.is-editor-empty:first-child::before {
            content: attr(data-empty-text);
            float: left;
            color: #aaa;
            pointer-events: none;
            height: 100%;
            font-style: italic;
        }
    }
    #file-input{
        display: none;
    }
}

.editor {
    p:last-child {
        margin-bottom: 0 !important;
    }
}
</style>
